import type { ComponentProps, ComponentType, SVGProps } from 'react';

import TasksMark from './logo.svg?react';
import KissCatMark from './wordmark.svg?react';

/** Which brand mark to render: the per-app wordmark or the shared KISS.cat one. */
export type LogoVariant = 'tasks' | 'kisscat';

interface VariantSpec {
	Mark: ComponentType<SVGProps<SVGSVGElement>>;
	label: string;
	width: number;
	height: number;
}

// Default size lives here (not the SVG) so it survives SVGO; override via props.
// Widths track each viewBox's aspect ratio at the shared ~22px header height.
const VARIANTS: Record<LogoVariant, VariantSpec> = {
	tasks: { Mark: TasksMark, label: 'tasks', width: 80, height: 22 },
	kisscat: { Mark: KissCatMark, label: 'KISS.cat', width: 123, height: 22 },
};

/**
 * A brand wordmark — an SVG imported via vite-plugin-svgr; swap the SVG to
 * re-brand. `variant` picks the mark: `tasks` (the pink cat-nose + "tasks", the
 * default) or `kisscat` (the shared KISS.cat wordmark used by the sign-in app).
 * Both use currentColor (the nose keeps its pink), so set `color` on a parent.
 */
export function Logo({
	variant = 'tasks',
	...props
}: ComponentProps<'svg'> & { variant?: LogoVariant }) {
	const { Mark, label, width, height } = VARIANTS[variant];
	return <Mark role="img" aria-label={label} width={width} height={height} {...props} />;
}
